module.exports = {
  USER_DATA: 'USER_WEB',
  ACCESS_TOKEN_WEB: 'ACCESS_TOKEN_WEB',
  REFRESH_TOKEN_WEB: 'REFRESH_TOKEN_WEB',
  URL_IMAGE: 'https://file-and-images.ppshope.com/images/',

  COLOR_APP: '#ff7843',

  PAGE_HOME: '/',
  GAME_DETAIL: '/game-detail',
  LOGIN: '/login',
  REGISTER: '/register',
  RESET_PASSWORD: '/password/reset',
  PROFILE: '/profile',
  CHANGE_PASSWORD: '/profile/change-password',
  RECHARGE: '/recharge',
  RECHARGE_2: '/recharge2/:paymentMethodId',
  HISTORY_GAME_INVOICE: '/history-games',
  HISTORY_VOUCHER_INVOICE: '/history-invoice/voucher',
  HISTORY_RECHARGE: '/history-recharge',
  PRIZE_WHEEL: '/prize-wheel',
  CHAT: '/chat',
  ABOUT: '/about',
  CONTACT: '/contact',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  REFUND_POLICY: '/refund-policy',
  GAME_VERIFY: '/game-verify',
  KYC: '/kyc',
};
  